module.exports = __webpack_public_path__ + "static/media/ic_upload_draft.002f8401.svg";